<api-error-alert *ngIf="error" [apiError]="error" [closable]="false"></api-error-alert>